module.exports = __webpack_public_path__ + "img/f530cb4.png";